import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { JwtService } from './services/commun/jwt.service';
import { MessageNotificationService } from './component/message-notification/message-notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'enegoceAngular';
  loading = false;
  currentUserId: string | null = null;
  showJuliaChat = false;

  constructor(
    private router: Router,
    private jwtService: JwtService,
    private messageNotificationService: MessageNotificationService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (event instanceof NavigationEnd) {
        this.loading = false;
        this.ShowJuliaChat();
      }
    });
  }

  ngOnInit() {
    this.ShowJuliaChat();
  }

  ngOnDestroy(): void {
    this.messageNotificationService.disconnect();
  }

  private ShowJuliaChat(): void {
    const userInfo = this.jwtService.getUserInfos();

    if (!userInfo || !userInfo.isAuthenticated || !userInfo.verified2Fa) {
      this.showJuliaChat = false;
      this.currentUserId = null;
      return;
    }

    const newUserId = String(userInfo.id);

    if (this.currentUserId !== newUserId) {
      this.currentUserId = newUserId;
      this.showJuliaChat = true;
    }
  }
}